import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import Img from 'gatsby-image';

import { BgImg } from '../../ui';

import './HeaderBanner.scss';

const HeaderBanner = ({ title, image }) => {
  const height = 250;
  return (
    <div className="services-header container">
      <Media query={{ minWidth: '768px' }}>
        {matches =>
          matches ? (
            <div>
              <h1
                style={{ margin: `0 0 ${height / 2 + 24}px 0` }}
                className="text-white"
              >
                {title}
              </h1>
              <BgImg
                alt={image.title}
                sizes={image.sizes}
                height={height}
                top="62px"
              />
            </div>
          ) : (
            <div>
              <h1
                style={{ margin: `0 0 ${height / 2 + 24 * 2}px 0` }}
                className="text-white"
              >
                {title}
              </h1>
              <BgImg
                alt={image.title}
                sizes={image.sizes}
                height={height}
                top="62px"
              />
            </div>
          )
        }
      </Media>
    </div>
  );
};

HeaderBanner.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};

export default HeaderBanner;



// WEBPACK FOOTER //
// ./src/components/Main/services/HeaderBanner.js